import styles from './IconDefault.module.scss';

export function IconMessage() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.89865 4.16602C6.64091 4.16602 4 6.74252 4 9.92079V27.1851C4 30.3634 6.64091 32.9399 9.89865 32.9399H10.8535C11.4058 32.9399 11.8535 33.3876 11.8535 33.9399V37.5275C11.8535 38.3541 12.7995 38.8238 13.458 38.3241L20.2855 33.1433C20.4594 33.0113 20.6717 32.9399 20.89 32.9399H33.4932C36.751 32.9399 39.3919 30.3634 39.3919 27.1851V9.92079C39.3919 6.74252 36.751 4.16602 33.4932 4.16602H9.89865Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M7.41622 31.0063H8.69426C8.80285 31.0063 8.89088 31.0922 8.89088 31.1981V37.8076C8.89088 37.9672 9.07907 38.057 9.20822 37.959L18.3176 31.0467C18.3521 31.0205 18.3946 31.0063 18.4383 31.0063H31.0108C34.2685 31.0063 36.9095 28.4298 36.9095 25.2515V7.9872C36.9095 6.1047 35.983 4.43331 34.5506 3.38338M3.38548 29.4532C2.23593 28.4031 1.51758 26.9091 1.51758 25.2515V7.9872C1.51758 4.80892 4.15849 2.23242 7.41622 2.23242H24.1875"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.03125 16.0801C7.03125 14.4232 8.40755 13.0801 10.1053 13.0801C11.8031 13.0801 13.1794 14.4232 13.1794 16.0801C13.1794 17.7369 11.8031 19.0801 10.1053 19.0801C8.40755 19.0801 7.03125 17.7369 7.03125 16.0801ZM16.2532 16.0801C16.2532 14.4232 17.6295 13.0801 19.3273 13.0801C21.025 13.0801 22.4013 14.4232 22.4013 16.0801C22.4013 17.7369 21.025 19.0801 19.3273 19.0801C17.6295 19.0801 16.2532 17.7369 16.2532 16.0801ZM28.5492 13.0801C26.8514 13.0801 25.4751 14.4232 25.4751 16.0801C25.4751 17.7369 26.8514 19.0801 28.5492 19.0801C30.247 19.0801 31.6233 17.7369 31.6233 16.0801C31.6233 14.4232 30.247 13.0801 28.5492 13.0801Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M28.6348 2.25781C28.6348 2.8101 28.1871 3.25781 27.6348 3.25781C27.0825 3.25781 26.6348 2.8101 26.6348 2.25781C26.6348 1.70553 27.0825 1.25781 27.6348 1.25781C28.1871 1.25781 28.6348 1.70553 28.6348 2.25781Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M31.9355 2.25781C31.9355 2.8101 31.4878 3.25781 30.9355 3.25781C30.3833 3.25781 29.9355 2.8101 29.9355 2.25781C29.9355 1.70553 30.3833 1.25781 30.9355 1.25781C31.4878 1.25781 31.9355 1.70553 31.9355 2.25781Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
		</svg>
	);
}
